import { render, staticRenderFns } from "./LayoutsUseOfBarSection.vue?vue&type=template&id=6fa97ceb"
import script from "./LayoutsUseOfBarSection.vue?vue&type=script&lang=ts"
export * from "./LayoutsUseOfBarSection.vue?vue&type=script&lang=ts"
import style0 from "./LayoutsUseOfBarSection.vue?vue&type=style&index=0&id=6fa97ceb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports